const SELECTOR = ".border";
const VARIABLES = ["--border-width", "--border-height", "--border-gap"];

const toPixels = (value) => {
    const number = Number.parseFloat(value);
    if (!Number.isFinite(number)) return Number.NaN;
    if (!value.endsWith("rem")) return number;

    const rootSize = Number.parseFloat(
        getComputedStyle(document.documentElement).fontSize,
    );

    return number * (Number.isFinite(rootSize) ? rootSize : 16);
};

const readVariables = (element) => {
    const styles = getComputedStyle(element);
    return VARIABLES.map((name) => toPixels(styles.getPropertyValue(name).trim()));
};

/**
 * Répartit les tirets sur tout le périmètre du tracé : leur largeur reste
 * constante, seuls les espaces absorbent le reste pour éviter un motif
 * tronqué au point de bouclage.
 */
const update = (svg) => {
    const rect = svg.querySelector("rect");
    if (!rect) return;

    const perimeter = rect.getTotalLength();
    if (!(perimeter > 0)) return;

    const [width, height, gap] = readVariables(svg);
    if (![width, height, gap].every(Number.isFinite)) return;

    // stroke-linecap: round allonge le tiret de --border-height de chaque côté.
    const dash = Math.max(0.01, width - height);
    const count = Math.max(1, Math.floor(perimeter / (width + gap)));
    const spacing = (perimeter - count * width) / count + height;

    rect.style.strokeDasharray = `${dash}px ${spacing}px`;
};

const collect = (root) => {
    const borders = [...(root.querySelectorAll?.(SELECTOR) ?? [])];
    if (root.matches?.(SELECTOR)) borders.unshift(root);
    return borders;
};

export default function initDashedBorder(root = document) {
    const borders = collect(root);
    if (borders.length === 0) return;

    const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => update(entry.target));
    });

    borders.forEach((svg) => {
        update(svg);
        observer.observe(svg);
    });

    return () => {
        observer.disconnect();
        borders.forEach((svg) => {
            svg.querySelector("rect")?.style.removeProperty("stroke-dasharray");
        });
    };
}
